module.exports = __webpack_public_path__ + "img/changeMode.e3958293.svg";